import { EditOutlined, FavoriteOutlined, NavigationOutlined } from '@mui/icons-material';
import { Checkbox, Grid, Paper, Box, Badge, Avatar, Fab } from '@mui/material';
import React from 'react';
import CAppSubTitle from '../../../../../app/components/CAppSubTitle';

const CTestUiComponents = () => {
	return (
		<>
			<Grid container spacing={3}>
				<Grid item sm={4}>
					<CAppSubTitle
						title="Checkboxes"
						subtitle="disabled checked | disabled | defaultChecked | medium | small | nothing"
					/>
					<Box>
						<Checkbox disabled checked /> <Checkbox disabled /> <Checkbox defaultChecked />
						<Checkbox defaultChecked size="medium" />
						<Checkbox defaultChecked size="small" /> <Checkbox /> No color
					</Box>
					<Box>
						<Checkbox color="default" disabled checked /> <Checkbox color="default" disabled />{' '}
						<Checkbox color="default" defaultChecked />
						<Checkbox color="default" defaultChecked size="medium" />
						<Checkbox color="default" defaultChecked size="small" /> <Checkbox color="default" /> Default
					</Box>
					<Box>
						<Checkbox color="primary" disabled checked /> <Checkbox color="primary" disabled />{' '}
						<Checkbox color="primary" defaultChecked />
						<Checkbox color="primary" defaultChecked size="medium" />
						<Checkbox color="primary" defaultChecked size="small" /> <Checkbox color="primary" /> Primary
					</Box>
					<Box>
						<Checkbox color="secondary" disabled checked /> <Checkbox color="secondary" disabled />{' '}
						<Checkbox color="secondary" defaultChecked />
						<Checkbox color="secondary" defaultChecked size="medium" />
						<Checkbox color="secondary" defaultChecked size="small" /> <Checkbox color="secondary" />{' '}
						Secondary
					</Box>
					<Box>
						<Checkbox color="error" disabled checked /> <Checkbox color="error" disabled />{' '}
						<Checkbox color="error" defaultChecked />
						<Checkbox color="error" defaultChecked size="medium" />
						<Checkbox color="error" defaultChecked size="small" /> <Checkbox color="error" /> Error
					</Box>
					<Box>
						<Checkbox color="info" disabled checked /> <Checkbox color="info" disabled />{' '}
						<Checkbox color="info" defaultChecked />
						<Checkbox color="info" defaultChecked size="medium" />
						<Checkbox color="info" defaultChecked size="small" /> <Checkbox color="info" /> Info
					</Box>
					<Box>
						<Checkbox color="warning" disabled checked /> <Checkbox color="warning" disabled />{' '}
						<Checkbox color="warning" defaultChecked />
						<Checkbox color="warning" defaultChecked size="medium" />
						<Checkbox color="warning" defaultChecked size="small" /> <Checkbox color="warning" /> Warning
					</Box>
					<Box>
						<Checkbox color="success" disabled checked /> <Checkbox color="success" disabled />{' '}
						<Checkbox color="success" defaultChecked />
						<Checkbox color="success" defaultChecked size="medium" />
						<Checkbox color="success" defaultChecked size="small" /> <Checkbox color="success" /> Success
					</Box>
				</Grid>
				<Grid item sm={4}>
					<CAppSubTitle title="Badges" subtitle="overlap | badgeContent" />
					<Box>
						<Grid container alignItems="center" spacing={3}>
							<Grid item sm={3}>
								<Badge color="primary" badgeContent="12">
									<Paper variant="outlined" square>
										RECT
									</Paper>
								</Badge>
							</Grid>
							<Grid item sm={3}>
								<Badge color="primary" badgeContent="12" variant="dot">
									<Paper variant="outlined" square>
										RECT DOT
									</Paper>
								</Badge>
							</Grid>
							<Grid item sm={3}>
								<Badge color="secondary" overlap="circular" badgeContent="12">
									<Avatar>C</Avatar>
								</Badge>
							</Grid>
							<Grid item sm={3}>
								<Badge color="secondary" overlap="circular" badgeContent="12" variant="dot">
									<Avatar>D</Avatar>
								</Badge>
							</Grid>
							<Grid item sm={3}>
								<Badge color="primary" badgeContent={12000} max={99}>
									<Paper variant="outlined" square>
										MAX
									</Paper>
								</Badge>
							</Grid>
							<Grid item sm={3}>
								<Badge color="default" badgeContent="12">
									<Paper variant="outlined" square>
										DEFAULT
									</Paper>
								</Badge>
							</Grid>
							<Grid item sm={3}>
								<Badge color="primary" badgeContent="12">
									<Paper variant="outlined" square>
										PRIMARY
									</Paper>
								</Badge>
							</Grid>
							<Grid item sm={3}>
								<Badge color="secondary" badgeContent="12">
									<Paper variant="outlined" square>
										SECONDARY
									</Paper>
								</Badge>
							</Grid>
							<Grid item sm={3}>
								<Badge color="error" badgeContent="12">
									<Paper variant="outlined" square>
										ERROR
									</Paper>
								</Badge>
							</Grid>
							<Grid item sm={3}>
								<Badge color="info" badgeContent="12">
									<Paper variant="outlined" square>
										INFO
									</Paper>
								</Badge>
							</Grid>
							<Grid item sm={3}>
								<Badge color="success" badgeContent="12">
									<Paper variant="outlined" square>
										SUCCESS
									</Paper>
								</Badge>
							</Grid>
							<Grid item sm={3}>
								<Badge color="warning" badgeContent="12">
									<Paper variant="outlined" square>
										WARNING
									</Paper>
								</Badge>
							</Grid>
						</Grid>
					</Box>
					<CAppSubTitle title="Fab" subtitle="size | colors | disabled | variant" />
					<Grid
						container
						alignItems="center"
						justifyContent="center"
						spacing={3}
						sx={{ textAlign: 'center' }}
					>
						<Grid item sm={3}>
							<Box>Primary</Box>
							<Fab color="primary">
								<EditOutlined />
							</Fab>
						</Grid>
						<Grid item sm={3}>
							<Box>Secondary</Box>
							<Fab color="secondary">
								<EditOutlined />
							</Fab>
						</Grid>
						<Grid item sm={3}>
							<Box>Default</Box>
							<Fab color="default">
								<EditOutlined />
							</Fab>
						</Grid>
						<Grid item sm={3}>
							<Box>Inherit</Box>
							<Fab color="inherit">
								<EditOutlined />
							</Fab>
						</Grid>
						<Grid item sm={3}>
							<Box>Error</Box>
							<Fab color="error">
								<EditOutlined />
							</Fab>
						</Grid>
						<Grid item sm={3}>
							<Box>Warning</Box>
							<Fab color="warning">
								<EditOutlined />
							</Fab>
						</Grid>
						<Grid item sm={3}>
							<Box>Info</Box>
							<Fab color="info">
								<EditOutlined />
							</Fab>
						</Grid>
						<Grid item sm={3}>
							<Box>Success</Box>
							<Fab color="success">
								<EditOutlined />
							</Fab>
						</Grid>
						<Grid item sm={3}>
							<Box>Small</Box>
							<Fab color="primary" size="small">
								<EditOutlined />
							</Fab>
						</Grid>
						<Grid item sm={3}>
							<Box>Medium</Box>
							<Fab color="primary" size="medium">
								<EditOutlined />
							</Fab>
						</Grid>
						<Grid item sm={3}>
							<Box>Large</Box>
							<Fab color="primary" size="large">
								<EditOutlined />
							</Fab>
						</Grid>
						<Grid item sm={3}>
							<Box>Disabled</Box>
							<Fab disabled aria-label="like">
								<FavoriteOutlined />
							</Fab>
						</Grid>
						<Grid item sm={4}>
							<Box>Extend</Box>
							<Fab variant="extended" size="small">
								<NavigationOutlined sx={{ mr: 1 }} />
								Small
							</Fab>
						</Grid>
						<Grid item sm={4}>
							<Box>Extend</Box>
							<Fab variant="extended" size="medium">
								<NavigationOutlined sx={{ mr: 1 }} />
								Medium
							</Fab>
						</Grid>
						<Grid item sm={4}>
							<Box>Extend</Box>
							<Fab variant="extended" size="large">
								<NavigationOutlined sx={{ mr: 1 }} />
								Large
							</Fab>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={4}>
					<CAppSubTitle title="Radio" subtitle="size | colors | disabled" />
				</Grid>
			</Grid>
		</>
	);
};

export default CTestUiComponents;
